module.exports = __webpack_public_path__ + "static/img/8.51055bea.png";